function urlWithParams(url: string) {
  return (params?: string) => {
    if (!params) return url;
    return `${url}${params}`;
  };
}

// Always end URLs with slashes: https://stackoverflow.com/a/47137013
export const myProfile = urlWithParams("/me/");
export const eventCreate = urlWithParams("/events/create/");
export const eventBaseCreate = urlWithParams("/event_bases/create/");
export const exportPath = urlWithParams("/export/");
export const infoPage = urlWithParams("/info/");
export const logoutPage = urlWithParams("/logout/");
export const integratedApplications = urlWithParams("/integrated_applications/");
export const profilePage = urlWithParams("/profile/");
export const customerPage = urlWithParams("/customer/");
export const permissionDeniedPage = urlWithParams("/Permission_denied/");
export const feedbackPage = urlWithParams("/feedback/:signed_id");
export const enrollmentApprovalPage = urlWithParams("/enrollment_approval/:signed_id");
export const placeholderJsonDownload = urlWithParams("/placeholder/json/download");
export const consentConfirmationPage = urlWithParams("/consent_confirmation/:token");
